"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkEdit = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var react_1 = __importDefault(require("react"));
var bulk_edit_header_styles_1 = require("./bulk_edit_header.styles");
var global_styles_1 = require("../../Global/global.styles");
var BulkEdit = function (props) {
    var selectedFlatRows = props.selectedFlatRows, toggleRowSelected = props.toggleRowSelected, removeRow = props.removeRow, children = props.children;
    var onClickDelete = function () {
        selectedFlatRows.forEach(function (row) {
            if (removeRow) {
                removeRow(row);
            }
        });
    };
    return (react_1.default.createElement(bulk_edit_header_styles_1.StyledBulkEdit, null,
        react_1.default.createElement(global_styles_1.FlexContainer, null,
            react_1.default.createElement(bulk_edit_header_styles_1.BulkEditText, null, selectedFlatRows.length + ' selected'),
            react_1.default.createElement(bulk_edit_header_styles_1.BulkEditDivider, { textColor: 'tertiary' }, '|'),
            react_1.default.createElement(bulk_edit_header_styles_1.BulkEditText, { textColor: 'tertiary' }, 'BULK EDIT'),
            react_1.default.createElement(bulk_edit_header_styles_1.ChildrenContainer, null, children),
            react_1.default.createElement(storm_ui_1.Button, { small: true, onClick: onClickDelete }, "Delete")),
        react_1.default.createElement(bulk_edit_header_styles_1.ClearButton, { onClick: function () { return selectedFlatRows.forEach(function (row) { return toggleRowSelected(row.id); }); }, "data-testid": 'clear-row-toggles' },
            react_1.default.createElement(storm_ui_1.Icon, { type: 'times', size: '2x' }))));
};
exports.BulkEdit = BulkEdit;
